import { crypto, md5Data } from './des' //引入加密文件



export function getRequestData (bizData) {

    let requestDataJson = getRequestDataStruct();
    requestDataJson.data = crypto(bizData); // Base64转码
    requestDataJson.sign = md5Data(requestDataJson.cmd, requestDataJson.data, requestDataJson.userName);
    return requestDataJson

}

function getRequestDataStruct () {
    let requestDataJson = {
        data: "",
        version: "1.0",
        sign: "",
        userName: "tuikeOp",
        cmd: "oplogin",
        appId: "111"
    }
    return requestDataJson
}